// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
        ? self
        : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
            ? global
            : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"9aw94":[function(require,module,exports,__globalThis) {
require("2f340e57fe636879").register(require("82deb2e95947fa").getBundleURL('kkkhJ'), JSON.parse("[\"kkkhJ\",\"index.bef023b2.js\",\"5vcKv\",\"atlassian-light.97fc050d.js\",\"6o6gJ\",\"atlassian-light-future.c1f64aa4.js\",\"29n0N\",\"atlassian-light-increased-contrast.ed2aedb7.js\",\"7MiB3\",\"atlassian-dark.19cd77e5.js\",\"9kzPW\",\"atlassian-dark-future.67ead8c2.js\",\"7BlKt\",\"atlassian-dark-increased-contrast.815eb469.js\",\"auqcp\",\"atlassian-spacing.8f980524.js\",\"1wUNB\",\"atlassian-typography.fa4b4fa5.js\",\"l51TO\",\"atlassian-shape.956e3a3d.js\",\"bZZmZ\",\"atlassian-motion.5bb50f7b.js\",\"kctVh\",\"custom-theme.b34b748f.js\",\"MPOnK\",\"cs.735f492c.js\",\"gVDfT\",\"da.a8cb26bd.js\",\"dIrro\",\"de.2c7ec453.js\",\"6KHZa\",\"en_GB.100e4a49.js\",\"aB9xC\",\"en_ZZ.73de8207.js\",\"byFnW\",\"es.ddccfb79.js\",\"aM5FL\",\"fi.90bc3ca9.js\",\"lPVP4\",\"fr.86905445.js\",\"4E3Up\",\"hu.656edb85.js\",\"31T3F\",\"it.f3b6cd1f.js\",\"kU8UN\",\"ja.5bb40d1d.js\",\"jUKrZ\",\"ko.57f4cf24.js\",\"2P4VV\",\"nb.af88fb81.js\",\"fQjeh\",\"nl.c0842bbe.js\",\"5ytOl\",\"pl.a56a1805.js\",\"2kbmC\",\"pt_BR.91ed5084.js\",\"aXMdp\",\"ru.a251c1d8.js\",\"cOHLf\",\"sl.fb8d42c4.js\",\"dYz4o\",\"sr_RS.4be72f93.js\",\"kM9hD\",\"sr_YR.f60ed2be.js\",\"TIhIi\",\"sv.849b4774.js\",\"6Nr8y\",\"th.c139483e.js\",\"iNazb\",\"tr.405cd7bb.js\",\"koG8I\",\"uk.9549a404.js\",\"4RuWj\",\"vi.5735a8f2.js\",\"lEIXr\",\"zh_TW.e919c010.js\",\"tfhRV\",\"zh.9badd81e.js\",\"7H8jk\",\"InactivePage.d1a18aad.js\",\"6oTyQ\",\"HistoryPage.68b696b0.js\",\"4iqdn\",\"HistoryPage.a8d75720.js\",\"eXsqj\",\"HistoryPage.dc777091.js\",\"gct5i\",\"IncidentDetailPage.b90b8f97.js\",\"274zX\",\"LiveStatusPage.60457146.js\"]"));

},{"2f340e57fe636879":"l4T2r","82deb2e95947fa":"cZKtR"}],"l4T2r":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"cZKtR":[function(require,module,exports,__globalThis) {
"use strict";
const stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function getBundleURLCached(id, inputError) {
    let value = bundleURL[id];
    if (!value) {
        value = getBundleURL(inputError);
        bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function getOrigin(url) {
    return new URL(url).origin;
}
// TODO: convert this file to ESM once HMR issues are resolved
exports.getOrigin = getOrigin;
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;

},{}]},["9aw94"], null, "parcelRequire213a")

//# sourceMappingURL=index.runtime.ef07d99d.js.map
